
import CreativeTeam from './CreativeTeam'
import Experience from './Experience'
import Why from './Why'
import Contact from '../Contact'
import Mover from './Mover'
import Brand from './Brand'
import BrandCarousel from './BrandCarousel'
import FullPageScroll from './FullPageScroll'
import Video from './Video'
const About = () => {
  return (
  <>
  <BrandCarousel />
  <Experience />
  <FullPageScroll />
  <CreativeTeam />
  <Video />
  <Why />
  <Mover />
  <Brand />
  <Contact />
  </>
  )
}

export default About
